import { RecordCount } from './gb-record-count';
riot.tag2('gb-record-count', '<yield> <h2>{first} - {last} of {total} Products</h2> </yield>', '', '', function(opts) {
    this._mixin(RecordCount);
});



/** WEBPACK FOOTER **
 ** ./src/tags/record-count/gb-record-count.tag.html
 **/